var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies } from "~/core/decorator";
import { OutsourceLawsuitService } from "~/services/domain-service/outsource-lawsuit-manage-index.service";
import { Emit, Prop } from "vue-property-decorator";
import FileUpload from "~/components/common/file-upload.vue";
import { FileUploadService } from "~/services/file-service/file-upload.service";
var AddCost = /** @class */ (function (_super) {
    __extends(AddCost, _super);
    function AddCost() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.fileList = [];
        _this.model = {
            costType: "",
            costEvent: "",
            momey: "",
            payTime: "",
            remark: "",
        };
        _this.rules = {
            costType: [
                { required: true, message: '请选择费用类别', trigger: 'blur' }
            ],
            costEvent: [
                { required: true, message: '请选择费用项', trigger: 'blur' }
            ],
            momey: [
                { required: true, message: '请输入费用金额', trigger: 'blur' }
            ],
            payTime: [
                { required: true, message: '请选择缴费时间', trigger: 'blur' }
            ],
            remark: [
                { required: true, message: '请输入备注', trigger: 'blur' }
            ],
        };
        return _this;
    }
    AddCost.prototype.refreshCostData = function () { };
    AddCost.prototype.close = function () {
        var form = this.$refs['add-cost'];
        form.resetFields();
        this.fileList = [];
    };
    AddCost.prototype.commit = function () {
        var _this = this;
        var form = this.$refs['add-cost'];
        form.validate(function (valid) {
            if (!valid)
                return;
            if (_this.fileList.length === 0) {
                _this.$message.error('请上传凭证');
                return;
            }
            var fileIds = _this.fileList.map(function (val) { return val.response.id; }).join(",");
            var id = _this.rowCostData ? _this.rowCostData.id : '';
            _this.outsourceLawsuitService.saveOrUpdateCostRecord(__assign(__assign({}, _this.model), { fileIds: fileIds, assistId: _this.rowData.id, id: id })).subscribe(function (data) {
                _this.$message.success("操作成功");
                _this.refreshCostData();
                _this.close();
            });
        });
    };
    AddCost.prototype.refresh = function () {
        var _this = this;
        if (!this.rowCostData) {
            this.$nextTick(function () {
                var form = _this.$refs['add-cost'];
                form.resetFields();
            });
            this.fileList = [];
            return;
        }
        this.model.costType = this.rowCostData.costType;
        this.model.costEvent = this.rowCostData.costEvent;
        this.model.momey = this.rowCostData.momey;
        this.model.payTime = this.rowCostData.payTime;
        this.model.remark = this.rowCostData.remark;
        this.callbackFileList(this.rowCostData.fileIds);
    };
    AddCost.prototype.callbackFileList = function (fileIds) {
        var _this = this;
        if (!fileIds)
            return;
        this.fileUploadService.getAllUploadFileByIds(fileIds).subscribe(function (data) {
            if (!data || data.length === 0)
                return;
            _this.fileList = data.map(function (v) {
                return { name: v.originalName, response: { id: v.id } };
            });
        });
    };
    __decorate([
        Dependencies(OutsourceLawsuitService)
    ], AddCost.prototype, "outsourceLawsuitService", void 0);
    __decorate([
        Dependencies(FileUploadService)
    ], AddCost.prototype, "fileUploadService", void 0);
    __decorate([
        Prop()
    ], AddCost.prototype, "rowData", void 0);
    __decorate([
        Prop()
    ], AddCost.prototype, "rowCostData", void 0);
    __decorate([
        Emit("refreshCostData")
    ], AddCost.prototype, "refreshCostData", null);
    __decorate([
        Emit("close")
    ], AddCost.prototype, "close", null);
    AddCost = __decorate([
        Component({
            components: {
                FileUpload: FileUpload
            }
        })
    ], AddCost);
    return AddCost;
}(Vue));
export default AddCost;
